import { inject, Injectable } from '@angular/core';
import { MarketColumn } from '@clean-code/models';
import { ID } from '@clean-code/models/common';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MarketDashboardSignalStore } from './../+state/market-dashboard-signal.store';
import { MarketColumnDataService } from './../infrastructure/column.data.service';
import { MarketDashboardNormalizerService } from './../infrastructure/market-dashboard-normalizer.service';

@Injectable()
export class ColumnFacade {
  private service = inject(MarketColumnDataService);
  private marketDashboardSignalStore = inject(MarketDashboardSignalStore);
  private marketDashboardNormalizer = inject(MarketDashboardNormalizerService);

  add$(input: MarketColumn) {
    return this.service
      .add$(input)
      .pipe(
        tap((response: MarketColumn) =>
          this.marketDashboardSignalStore.upsertColumn(
            this.marketDashboardNormalizer.normalizeColumn(response),
          ),
        ),
      );
  }

  update$(input: MarketColumn) {
    return this.service
      .update$(input)
      .pipe(
        tap((response: MarketColumn) =>
          this.marketDashboardSignalStore.upsertColumn(
            this.marketDashboardNormalizer.normalizeColumn(response),
          ),
        ),
      );
  }

  getAll$(dashboardId: ID): Observable<MarketColumn[]> {
    return this.service.getAll$(dashboardId);
  }

  getById$(_id: ID) {
    return this.service.getById$(_id);
  }

  delete$(id: ID) {
    return this.service
      .delete$(id)
      .pipe(tap(() => this.marketDashboardSignalStore.removeColumn(id)));
  }
}
